import angular from 'angular'
import OfferEdit from 'emun.offer/offer-edit'
import OffersList from 'emun.offer/offers-list'
import scss from 'emun.offer/offers.scss'

const dependencies = ['emun.auth','webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('emun.offer', dependencies)
.component('offerEdit', OfferEdit)
.component('offersList', OffersList)
.name;